module.exports = __webpack_public_path__ + "img/few_building_out.fc5ff9a4.png";